export default "__VITE_ASSET__COVfTku___"